"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBridgePool = exports.getBridgeProgram = void 0;
const config_1 = require("../config");
const anchor_1 = require("@project-serum/anchor");
const getConncetion_1 = require("./getConncetion");
const web3_js_1 = require("@solana/web3.js");
let program;
const bridgePoolMap = new Map();
function getBridgeProgram(connection, marketConfig) {
    return __awaiter(this, void 0, void 0, function* () {
        if (program) {
            return program;
        }
        else {
            // @ts-ignore
            return program = new anchor_1.Program(config_1.BRIDGE_POOL_IDL, marketConfig.bridgeProgramId, yield (0, getConncetion_1.getProvider)(connection));
        }
    });
}
exports.getBridgeProgram = getBridgeProgram;
function getBridgePool(bridgePoolID, connection, marketConfig) {
    return __awaiter(this, void 0, void 0, function* () {
        let bridgePool = bridgePoolMap.get(bridgePoolID.toString());
        if (!bridgePool) {
            if (bridgePoolID.toString() === "3AqvcSZnb6QxN6Q1m7WT1kVkzV9Pp6WypTtm4ZmcSr1W") {
                bridgePool = {
                    version: 0,
                    base: web3_js_1.PublicKey.default,
                    owner: web3_js_1.PublicKey.default,
                    pendingOwner: web3_js_1.PublicKey.default,
                    ammId: new web3_js_1.PublicKey("58oQChx4yWmvKdwLLZzBi4ChoCc2fqCUWBkwMihLYQo2"),
                    ammVersion: 0,
                    lpMint: new web3_js_1.PublicKey("8HoQnePLqPj4M7PUDzfw8e3Ymdwgc7NLGnaTUapubyvu"),
                    lpSupply: new web3_js_1.PublicKey("8Brvkr2XB5kPz2fdBN5HhKVUa7zq4QsuL3ws9e2UDTUG"),
                    coinSupply: new web3_js_1.PublicKey("3o4q4vWw9qRJEn5cCsjBBetanheuZd8oBtRZU3CoYJ5g"),
                    pcSupply: new web3_js_1.PublicKey("5V5mCEommAgrLcDe862GPLdQ6MFULwcffE7G3qHAxR2m"),
                    addLpWithdrawAmountAuthority: new web3_js_1.PublicKey("BxnUi6jyYbtEEgkBq4bPLKzDpSfWVAzgyf3TF2jfC1my"),
                    coinMintPrice: new web3_js_1.PublicKey("4b48cC9RJwmLxGSPZGgPSh2qdQfwqzsxp2AZRyAdtHSo"),
                    coinMintDecimal: 0,
                    pcMintPrice: new web3_js_1.PublicKey("7RhdnRymb4TqTYLM5bH7cALj86EZX2sFxH8KYUbhUmLB"),
                    pcMintDecimal: 0,
                    ammOpenOrders: new web3_js_1.PublicKey("HRk9CMrpq7Jn9sh7mzxE8CChHG8dneX9p475QKz4Fsfc"),
                    ammCoinMintSupply: new web3_js_1.PublicKey("DQyrAcCrDXQ7NeoqGgDCZwBvWDcYmFCjSb9JtteuvPpz"),
                    ammPcMintSupply: new web3_js_1.PublicKey("HLmqeL62xR1QoZ1HKKbXRrdN1p3phKpxRMb2VVopvBBz"),
                    bump: 255,
                    lpPriceAccount: new web3_js_1.PublicKey("BXYH5q3SAmGHPfnXacePDJBPHXJrNXGVxBm1s6S3QdNc"),
                    isFarm: true,
                    farmPoolId: new web3_js_1.PublicKey("GUzaohfNuFbBqQTnPgPSNciv3aUvriXYjQduRE3ZkqFw"),
                    farmPoolVersion: 0,
                    farmLedger: new web3_js_1.PublicKey("4P7zEup6X3Qf8mdPqEJfoM5Yq1dGLX8hQ633wHVSWykQ"),
                    rewardSupply: [new web3_js_1.PublicKey("DP2dF9t5zWoxxaYbaVUZzA8JZhPBNc2DTtr1u35S9AmE"), new web3_js_1.PublicKey("FqQCYiSkgeXkxG1BRMR1QWdpEYEbSJwcgs5HrFc9gbG5")]
                };
            }
            else {
                const bridgeProgram = yield getBridgeProgram(connection, marketConfig);
                bridgePool = (yield bridgeProgram.account.pool.fetch(bridgePoolID));
            }
            bridgePoolMap.set(bridgePoolID.toString(), bridgePool);
        }
        return bridgePool;
    });
}
exports.getBridgePool = getBridgePool;
